import { CharacteristicImage, ImageTransferResult, SampleImage } from '@core/data';

export type ImageMoveImageType = 'sample';

export interface ImageMoveStateModel {

    sourceEvalKey: string;

    imageType: ImageMoveImageType;

    selectedKeys: string[];
    selectedData: Array<SampleImage | CharacteristicImage>;

    transferResults: { [imageKey: string]: ImageTransferResult };
}

export const DEFAULTS: ImageMoveStateModel = {
    sourceEvalKey: null,
    imageType: null,
    selectedKeys: [],
    selectedData: [],
    transferResults: {},
};
